
(async function(){
if(window.ohCardWishlistInitialized)return;
window.ohCardWishlistInitialized=true;
const host=document.body;
let source;
for(let i=0;i<30;i++){
source=[...document.scripts].find(s=>s.src.includes('/wishlist_index.js'))?.src;
if(source && window._clrapp)break;
await new Promise(resolve=>setTimeout(resolve,300));
}
if(!source)return;
try{
const base=source.slice(0,source.lastIndexOf('/')+1);
const [app,widget]=await Promise.all([import(source),import(base+'wishlist_index-5uwfuggD.js')]);
const css=document.createElement('link');css.rel='stylesheet';css.href=base+'wishlist_index-5uwfuggD.css';document.head.append(css);
function mount(){
host.querySelectorAll('.section--product-recommendations product-card,.oh-color-section product-card,.section--recently-viewed-products product-card').forEach(card=>{
if(card.querySelector('.oh-look__wishlist'))return;
const link=card.querySelector('a[data-product-link]');
if(!link)return;
const slot=document.createElement('div');slot.className='oh-look__wishlist';slot.dataset.productUrl=link.getAttribute('href').split('?')[0];card.append(slot);
});
host.querySelectorAll('.oh-look__wishlist:not([data-oh-mounted])').forEach(slot=>{
slot.dataset.ohMounted='true';
const element=app.f.createWidgetElement('div',app.a.createElement(widget.default,{productLink:slot.dataset.productUrl}));
slot.append(element);
const observer=new MutationObserver(()=>{
const heart=slot.querySelector('.clr_add_to_wishlist');
if(!heart)return;
heart.setAttribute('role','button');heart.tabIndex=0;
heart.setAttribute('aria-label',heart.classList.contains('bookmarked')?'Usuń z ulubionych':'Dodaj do ulubionych');
heart.setAttribute('aria-pressed',String(heart.classList.contains('bookmarked')));
if(!heart.dataset.ohKeyboard){heart.dataset.ohKeyboard='true';heart.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();heart.click();}});}
});
observer.observe(slot,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
});
}
mount();
document.addEventListener('oh:cards-updated',mount);
new MutationObserver(mutations=>{
if(mutations.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('product-card,.swiper-slide')||n.querySelector?.('product-card')))))mount();
}).observe(host,{childList:true,subtree:true});
}catch(error){console.error('Nie udało się wczytać ulubionych w stylizacji',error);}
})();
